import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Plane, Home, Search } from "lucide-react";
import { SEOHead } from "@/components/SEOHead";

export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center px-4" data-testid="not-found-page">
      <SEOHead title="Page Not Found | OnwardFlighTickets" description="The page you're looking for doesn't exist." path="/404" />
      <div className="text-center max-w-sm">
        <div className="mb-6">
          <p className="font-['Outfit'] text-[80px] font-bold text-[#e2e8f0] leading-none">404</p>
        </div>
        <div className="w-14 h-14 bg-[#fff7ed] rounded-2xl flex items-center justify-center mx-auto mb-5">
          <Plane className="w-7 h-7 text-[#f97316] -rotate-45" />
        </div>
        <h1 className="font-['Outfit'] text-xl font-bold text-[#1e293b] mb-2">{t("error.not_found_title")}</h1>
        <p className="text-sm text-[#64748b] mb-8">{t("error.not_found_desc")}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate("/")}
            className="flex items-center justify-center gap-2 bg-[#1e3a5f] text-white px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-[#152e4d] transition-colors"
            data-testid="notfound-go-home"
          >
            <Home className="w-4 h-4" /> {t("error.go_home")}
          </button>
          <button
            onClick={() => navigate("/")}
            className="flex items-center justify-center gap-2 border border-[#f97316] text-[#f97316] px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-[#fff7ed] transition-colors"
            data-testid="notfound-search"
          >
            <Search className="w-4 h-4" /> {t("error.search_flights")}
          </button>
        </div>
      </div>
    </div>
  );
}
